import { render, staticRenderFns } from "./dotask-money.vue?vue&type=template&id=724afbef&scoped=true&lang=pug&"
import script from "./dotask-money.vue?vue&type=script&lang=js&"
export * from "./dotask-money.vue?vue&type=script&lang=js&"
import style0 from "./dotask-money.vue?vue&type=style&index=0&id=724afbef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724afbef",
  null
  
)

export default component.exports